import * as React from "react";
import FieldSelectBase from "views/components/aggregationwizard/FieldSelectBase";
import useFieldTypes from "data-lake/hooks/useFieldTypes";
const FieldSelect = (props) => {
  const { widgetFields } = useFieldTypes();
  return /* @__PURE__ */ React.createElement(FieldSelectBase, { options: widgetFields, ...props });
};
export default FieldSelect;
